import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "25",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#0000E7",
  "fill-rule": "evenodd",
  d: "M11.746.348a.9.9 0 0 1 .732 0l10.819 4.808a.9.9 0 0 1 0 1.648l-10.819 4.808a.9.9 0 0 1-.732 0L.928 6.804a.903.903 0 0 1 0-1.648zM3.513 5.98l8.599 3.822 8.599-3.822-8.599-3.822zM8.848 14.628a.9.9 0 0 1-.455 1.19l-4.884 2.181 8.603 3.823 8.603-3.823-4.883-2.181a.9.9 0 1 1 .735-1.646l6.731 3.005a.903.903 0 0 1-.001 1.648l-10.819 4.807a.9.9 0 0 1-.732 0L.928 18.825a.903.903 0 0 1-.002-1.648l6.732-3.005a.9.9 0 0 1 1.19.456",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#0000E7",
  "fill-rule": "evenodd",
  d: "M8.848 8.618a.9.9 0 0 1-.455 1.19l-4.884 2.181 8.603 3.823 8.603-3.823-4.883-2.181a.9.9 0 1 1 .735-1.646l6.731 3.005a.902.902 0 0 1-.001 1.647l-10.819 4.808a.9.9 0 0 1-.732 0L.928 12.814a.901.901 0 0 1-.002-1.647l6.732-3.005a.9.9 0 0 1 1.19.456",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }